<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Categorias - API</h6>
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <p class="text-sm mb-0">
          <span class="font-weight-bold">{{ categorias.length }}</span> categorias encontradas
        </p>
        <div class="d-flex flex-wrap gap-2">
          <button 
            @click="loadCategorias" 
            class="btn btn-sm"
            :class="loading ? 'btn-secondary' : 'btn-custom-gradient'"
            :disabled="loading"
          >
           {{ loading ? 'Carregando...' : 'Atualizar' }}
         </button>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="error" class="alert alert-danger mx-3">
        {{ error }}
      </div>
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-teal" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
      <div v-else class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Descrição
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Categoria
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="categoria in categorias" :key="categoria.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ categoria.description || categoria.nome || categoria.name || 'Sem descrição' }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      ID: {{ categoria.id }}
                    </p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-sm">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ getCategoryName(categoria.id_category) }}
                </span>
              </td>
              <td class="align-middle">
                <div class="d-flex align-items-center justify-content-end gap-2 pe-3">
                  <a
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Ver detalhes"
                    @click="viewDetails(categoria)"
                  >
                    Detalhes
                  </a>
                  <a
                    href="javascript:;"
                    class="text-info"
                    data-toggle="tooltip"
                    data-original-title="Editar categoria"
                    @click="editCategory(categoria)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="categorias.length === 0 && !loading">
              <td colspan="3" class="text-center py-4">
                <p class="text-secondary">Nenhuma categoria encontrada</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal de Editar Categoria -->
    <div v-if="showEditCategoryModal" class="modal-backdrop fade show" @click="closeEditModal" style="z-index: 9999;"></div>
    <div v-if="showEditCategoryModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="editCategoryApiModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editCategoryApiModalLabel">
              <i class="fas fa-edit me-2"></i>
              Editar Categoria API
            </h5>
            <button type="button" class="btn-close" @click="closeEditModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingEdit" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Atualizando categoria...</p>
            </div>
            <div v-else-if="editError" class="alert alert-danger">
              {{ editError }}
            </div>
            <div v-else>
              <form @submit.prevent="updateCategory">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="editCategoryDescription" class="form-label">Descrição da Categoria API</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="editCategoryDescription"
                      v-model="editCategoryData.description"
                      placeholder="Ex: Leites e derivados"
                      disabled
                      readonly
                    >
                  </div>
                  <div class="col-12 mb-3">
                    <label for="editCategoryIdCategory" class="form-label">Categoria</label>
                    <select 
                      class="form-select" 
                      id="editCategoryIdCategory"
                      v-model="editCategoryData.id_category"
                    >
                      <option :value="null">Selecione uma categoria</option>
                      <option 
                        v-for="cat in availableCategories" 
                        :key="cat.id" 
                        :value="cat.id"
                      >
                        {{ cat.nome || cat.name || 'Sem nome' }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditModal">Cancelar</button>
            <button 
              type="button" 
              class="btn btn-custom-gradient" 
              @click="updateCategory"
              :disabled="loadingEdit"
            >
              <i class="fas fa-save me-1"></i>
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Detalhes da Categoria -->
    <div v-if="showDetailsModal" class="modal-backdrop fade show" @click="closeDetailsModal" style="z-index: 9999;"></div>
    <div v-if="showDetailsModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="categoryApiDetailsModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered category-details-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="categoryApiDetailsModalLabel">
              <i class="fas fa-info-circle me-2"></i>
              Detalhes da Categoria API
            </h5>
            <button type="button" class="btn-close" @click="closeDetailsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-4">
            <div v-if="loadingDetails" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando detalhes da categoria...</p>
            </div>
            <div v-else-if="selectedCategory" class="row">
              <div class="col-md-6">
                <div class="category-icon-container text-center mb-3">
                  <div class="category-icon-placeholder">
                    <i class="fas fa-tags fa-5x text-info"></i>
                    <p class="text-muted mt-2">Categoria API</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="category-details ps-3">
                  <h6 class="text-primary mb-4">{{ selectedCategory.description || selectedCategory.nome || selectedCategory.name || 'Sem descrição' }}</h6>
                  
                  <div class="detail-item mb-4">
                    <strong>ID:</strong> {{ selectedCategory.id }}
                  </div>
                  
                  <div class="detail-item mb-4" v-if="selectedCategory.description">
                    <strong>Descrição:</strong>
                    <p class="text-muted mt-2 mb-0">
                      {{ selectedCategory.description }}
                    </p>
                  </div>
                  
                  <div class="detail-item mb-4">
                    <strong>Categoria:</strong>
                    <span class="text-muted ms-2">
                      {{ getCategoryName(selectedCategory.id_category) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-4">
              <div class="alert alert-danger">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Erro ao carregar detalhes da categoria
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_ENDPOINTS, apiRequest, handleApiResponse } from "@/config/api.js";
import { showSuccessAlert } from "@/utils/swal.js";

export default {
  name: "categorias-api-table",
  data() {
    return {
      categorias: [],
      loading: false,
      error: null,
      showEditCategoryModal: false,
      loadingEdit: false,
      editError: null,
      showDetailsModal: false,
      selectedCategory: null,
      editingCategory: null,
      loadingDetails: false,
      availableCategories: [],
      loadingCategories: false,
      editCategoryData: {
        description: '',
        id_category: null
      }
    };
  },
  mounted() {
    this.loadCategorias();
    this.loadAvailableCategories();
  },
  methods: {
    async loadCategorias() {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await apiRequest(API_ENDPOINTS.CATEGORY_API, {
          method: 'GET'
        });
        
        const data = await handleApiResponse(response);
        this.categorias = Array.isArray(data) ? data : (data.data || data.categorias || []);
        
        console.log('Categorias API carregadas:', this.categorias);
        
        // Carrega as categorias disponíveis para poder exibir os nomes
        if (this.availableCategories.length === 0) {
          await this.loadAvailableCategories();
        }
        
      } catch (error) {
        console.error('Erro ao carregar categorias API:', error);
        this.error = error.message || 'Erro ao carregar categorias API';
      } finally {
        this.loading = false;
      }
    },
    
    getCategoryName(idCategory) {
      if (!idCategory) {
        return 'Sem categoria';
      }
      
      const categoria = this.availableCategories.find(cat => cat.id === idCategory);
      if (categoria) {
        return categoria.nome || categoria.name || 'Sem nome';
      }
      
      return 'Categoria não encontrada';
    },
    
    async viewDetails(categoria) {
      this.showDetailsModal = true;
      this.selectedCategory = categoria;
      this.loadingDetails = true;
      
      try {
        // Busca os detalhes completos da categoria da API
        const response = await apiRequest(`${API_ENDPOINTS.CATEGORY_API}/${categoria.id}`, {
          method: 'GET'
        });
        
        const data = await handleApiResponse(response);
        this.selectedCategory = data;
        
        console.log('Detalhes da categoria API carregados:', data);
        
      } catch (error) {
        console.error('Erro ao carregar detalhes da categoria API:', error);
        // Se falhar, usa os dados da lista como fallback
        this.selectedCategory = categoria;
      } finally {
        this.loadingDetails = false;
      }
    },
    
    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedCategory = null;
      this.loadingDetails = false;
    },

    async editCategory(categoria) {
      this.editingCategory = categoria;
      this.editCategoryData = {
        description: categoria.description || categoria.nome || categoria.name || '',
        id_category: categoria.id_category || null
      };
      this.editError = null;
      this.showEditCategoryModal = true;
      
      // Carrega as categorias disponíveis se ainda não foram carregadas
      if (this.availableCategories.length === 0) {
        await this.loadAvailableCategories();
      }
    },
    
    async loadAvailableCategories() {
      this.loadingCategories = true;
      
      try {
        const response = await apiRequest(API_ENDPOINTS.CATEGORY, {
          method: 'GET'
        });
        
        const data = await handleApiResponse(response);
        this.availableCategories = Array.isArray(data) ? data : (data.data || data.categorias || []);
        
        console.log('Categorias disponíveis carregadas:', this.availableCategories);
        
      } catch (error) {
        console.error('Erro ao carregar categorias disponíveis:', error);
      } finally {
        this.loadingCategories = false;
      }
    },

    closeEditModal() {
      this.showEditCategoryModal = false;
      this.editingCategory = null;
      this.editError = null;
      this.editCategoryData = {
        description: '',
        id_category: null
      };
    },

    async updateCategory() {
      this.loadingEdit = true;
      this.editError = null;

      try {
        const categoryPayload = {};
        
        // Adiciona id_category ao payload se foi preenchido
        if (this.editCategoryData.id_category !== null && this.editCategoryData.id_category !== '') {
          categoryPayload.id_category = parseInt(this.editCategoryData.id_category);
        }
        
        // Se não houver id_category, não envia nada
        if (Object.keys(categoryPayload).length === 0) {
          this.editError = 'Selecione uma categoria';
          this.loadingEdit = false;
          return;
        }

        const response = await apiRequest(`${API_ENDPOINTS.CATEGORY_API}/${this.editingCategory.id}`, {
          method: 'PUT',
          body: JSON.stringify(categoryPayload)
        });

        await handleApiResponse(response);

        // Sucesso! Fecha o modal e recarrega a lista
        this.closeEditModal();
        this.loadCategorias();
        
        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Categoria API atualizada com sucesso!',
          'A categoria foi atualizada no sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao atualizar categoria API:', error);
        this.editError = error.message || 'Erro ao atualizar categoria API';
      } finally {
        this.loadingEdit = false;
      }
    },

  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modal-dialog {
  width: 100%;
  margin: 0.5rem auto;
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: calc(100% - 1rem);
    margin: 0.5rem;
  }
}

.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.spinner-teal {
  color: #20c997 !important;
}

.gap-2 {
  gap: 0.5rem;
}

.text-info:hover,
.text-danger:hover {
  opacity: 0.8;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.text-info,
.text-danger {
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.category-icon-placeholder {
  padding: 40px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.category-details {
  padding: 0 10px;
}

.detail-item {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}

.detail-item:last-child {
  border-bottom: none;
}

.modal-dialog.modal-lg {
  max-height: 80vh;
}

.modal-dialog.modal-lg .modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.modal-dialog.modal-lg .modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.category-details-modal {
  max-width: 75% !important;
  width: 75% !important;
}

@media (min-width: 1200px) {
  .category-details-modal {
    max-width: 900px !important;
    width: 900px !important;
  }
}
</style>

